(() => {
    var selectedFreeSwatchesValues = [];
    const btn = document.querySelector('[data-asset="button-free-samples"]');
    const modal = document.querySelector(".swatches-modal-wrapper");
    const closeBtn = modal.querySelector(".close-btn");
    const overlay = modal.querySelector(".modal-container");
    const cancelBtn = modal.querySelector(".action-btn.cancel");

    const productId = document.getElementById('add-to-cart-free-swatch').getAttribute('data-product-id');

    // Open Modal
    btn.addEventListener("click", async function(){
        const swatchesModal = document.querySelector('[data-asset="swatches-modal-content"]');
        swatchesModal.classList.add('popup-loading');
        modal.classList.add("active");
        document.querySelector('body').classList.add('swatch-popup-active');
        const cartVarintIds = await isProductInCart(productId);
        cartVarintIds.forEach(variantId => {
            const inputElement = document.querySelector(`input[name="free-fabric-swatch"][data-variant-id="${variantId}"]`);
            addSelectedVariant(inputElement);
        });
        swatchesModal.classList.remove('popup-loading');
    });

    // Close Modal function
    function closeModal() {
        modal.classList.remove("active");
        document.querySelector('body').classList.add('swatch-popup-active');
        const removeSwatchCards = document.querySelectorAll('[data-action="remove-selected-free-fabric-swatch"]');
        removeSwatchCards.forEach(function(removeCard) {
            removeSelectedCard(removeCard);
        });
    }

    // Event listeners for closing modal
    closeBtn.addEventListener("click", closeModal);
    cancelBtn.addEventListener("click", closeModal);
    
    overlay.addEventListener("click", function(e){
        if (e?.target === this) {
            closeModal();
        } 
    });

    document.addEventListener("keydown", function(e){
        if ((e?.keyCode === 27 || e?.keyCode === 'Escape') && modal.classList.contains("active")) {
            closeModal();
        }
    });

    function checkSelectedFreeSwatchesHaveDublicateValue(valueToBeChecked) {
        var returnValue = false;
        if (selectedFreeSwatchesValues.length > 0 && valueToBeChecked) {
            selectedFreeSwatchesValues.forEach(function (value) {
                if (valueToBeChecked == value) {
                    returnValue = true;
                }
            });
        }
        return returnValue;
    }

    const swatchCards = document.querySelectorAll('.swatches-image-card');

    swatchCards.forEach(function(card) {
        card.addEventListener('click', function(event) {
            event.preventDefault();
            swatchCards.forEach(function(cardElement) {
                cardElement.classList.remove('selected-swatch');
            });
            this.classList.add('selected-swatch');
            const inputElement = card.querySelector('input[name="free-fabric-swatch"]');
            addSelectedVariant(inputElement);
        });
    });

    function addSelectedVariant(inputElement) {
        const maximumSwatchLimit = inputElement.getAttribute('data-swatch-limit');
        if (selectedFreeSwatchesValues.length >= maximumSwatchLimit) {
            displayMessage('Maximum limit reached', "error")
        } else {
            var index = checkSelectedFreeSwatchesHaveDublicateValue(inputElement.getAttribute('data-variant-id'));
            if (index == false) {
                let selectedFreeFabricVariantId = inputElement.getAttribute('data-variant-id');
                let selectedFreeFabricMaterial = inputElement.getAttribute('data-material');
                let selectedFreeFabricSwatchImage = inputElement.getAttribute('data-variant-image');
                let selectedFreeFabricTitle = inputElement.getAttribute('data-variant-title');
                let isValueSet = false;
                document.querySelectorAll('[data-asset="selected-free-fabric-swatches"] input[type="radio"]').forEach(function(selectedInputElement) {
                    if (!isValueSet && selectedInputElement.value === "") {
                        selectedInputElement.value = selectedFreeFabricVariantId;
                        selectedInputElement.setAttribute('data-material', selectedFreeFabricMaterial);
                        selectedInputElement.setAttribute('data-variant-name', selectedFreeFabricTitle);
                        let selectedCard = selectedInputElement.closest('.selected-card.item-selected');
                        selectedCard.style.backgroundImage = "url(" + selectedFreeFabricSwatchImage + ")";
                        var buttonElement = selectedInputElement.nextElementSibling;
                        buttonElement.classList.remove('invicible');
                        var titleElement = buttonElement.parentElement.nextElementSibling;
                        titleElement.textContent = selectedFreeFabricTitle;
                        selectedFreeSwatchesValues.push(selectedFreeFabricVariantId);
                        isValueSet = true;
                    }
                });
            } else {
                displayMessage('Swatch Already Added!', "error");
            }
        }
    }

    function displayMessage(message, type){
        const toggleMessages = document.querySelector('[data-asset="free-sample-template-message"]');
        toggleMessages.textContent = message;
        toggleMessages.classList.remove('invicible');
        toggleMessages.classList.add(type);
        setTimeout(function() {
            toggleMessages.classList.add('invicible');
            toggleMessages.classList.remove(type);
        }, 1500);
    }

    const removeSwatchCards = document.querySelectorAll('[data-action="remove-selected-free-fabric-swatch"]');
    removeSwatchCards.forEach(function(removeCard) {
        removeCard.addEventListener('click',async function(event) {
            event.preventDefault();
            removeSelectedCard(removeCard);
        });
    });

    function removeSelectedCard(removeCard) {
        removeCard.classList.add('invicible');
        let previousElement = removeCard.previousElementSibling;
        if (previousElement.value != '') {
            var index = checkSelectedFreeSwatchesHaveDublicateValue(previousElement.value);
            if (index == true) {
                var valueToRemove = previousElement.value;
                selectedFreeSwatchesValues = selectedFreeSwatchesValues.filter(function(value) {
                    return parseInt(value, 10) !== parseInt(valueToRemove, 10);
                });
            }
        }
        previousElement.value = '';
        previousElement.setAttribute('data-material', '');
        var parentElement = previousElement.parentElement;
        parentElement.style.backgroundImage = "";
        var titleElement = removeCard.parentElement.nextElementSibling;
        titleElement.textContent = '';
    }

    document.getElementById('add-to-cart-free-swatch').addEventListener('click', function(event) {
        event.preventDefault();
        handleAddToCart(productId);
        this.disabled = true;
    });

    async function handleAddToCart(productId) {
        try {
            var swatchLimit = document.getElementById('add-to-cart-free-swatch').getAttribute('data-swatch-limit');
            var addToCart = true;

            await removeAllProductVariants(productId);

            if (addToCart) {
                let cartData = {
                    items: []
                };

                selectedFreeSwatchesValues.forEach(function (value) {
                    cartData.items.push({ id: value, quantity: 1 });
                });

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(cartData),
                });
                window.location.replace('/cart');
            }
            document.getElementById('add-to-cart-free-swatch').disabled = false;
        } catch (error) {
            console.error('Error fetching variant IDs or adding to cart:', error);
        }
    }

    async function removeAllProductVariants(productId) {
        try {
            var variantsToRemove = await isProductInCart(productId);
            let updates = {};
            variantsToRemove.forEach(item => {
                updates[item] = 0;
            });
            if (Object.keys(updates).length > 0) {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates })
                });
            }
        } catch (error) {
            console.error('Error updating the cart:', error);
        }
    }

    function isProductInCart(productId) {
        return fetch('/cart.js')
        .then(response => response.json()) // Parse the JSON response
        .then(cart => {
            var itemId = [];
            for (let item of cart.items) {
                if (item.product_id == productId) {
                    itemId.push(item.variant_id);
                }
            }
            return itemId;
        })
        .catch(error => {
            console.error('Error fetching cart data:', error);
        });
    }

    const fabricFilterElement = document.querySelectorAll('.filter-swatch-card');
    fabricFilterElement.forEach(function(fabricFilter) {
        fabricFilter.addEventListener('click', function(event) {
            event.preventDefault();
            fabricFilterElement.forEach(function(filter) {
                filter.classList.remove('selected-filter');
            });
            this.classList.add('selected-filter');
            var fabricInputElement = event.currentTarget.querySelector('input[type="radio"]');
            var fabricTitleElement = document.querySelector('[data-asset="selected_free_swatches_filter_fabric"]');
            fabricTitleElement.textContent = fabricInputElement.value;
            var resetButton = document.querySelector('#free_swatches_reset');
            resetButton.classList.remove('invicible');
            const swatchCards = document.querySelectorAll('.swatches-image-card input[type="radio"]');

            swatchCards.forEach(function(swatch) {
                let swatchMaterial = swatch.getAttribute('data-material');

                if (swatchMaterial === fabricInputElement.value) {
                    swatch.closest('.swatches-image-card').classList.remove('invicible');
                } else {
                    swatch.closest('.swatches-image-card').classList.add('invicible');
                }
            });
        });
    });

    document.getElementById('free_swatches_reset').addEventListener('click', function() {
        const swatchCards = document.querySelectorAll('.swatches-image-card input[type="radio"]');

        swatchCards.forEach(function(swatch) {
            swatch.closest('.swatches-image-card').classList.remove('invicible');
        });

        this.classList.add('invicible');
        document.querySelector('[data-asset="selected_free_swatches_filter_fabric"]').textContent = '';
        const fabricFilterElement = document.querySelectorAll('.filter-swatch-card');
        fabricFilterElement.forEach(function(filter) {
            filter.classList.remove('selected-filter');
        });
    });
})();
